import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { SkipSubscriptionDetails } from '../../../shared/models/product';
import { ProductsService } from '../products.service';

@Component({
  selector: 'skip-subscription',
  templateUrl: './skip-subscription.component.html',
  styleUrls: ['./skip-subscription.component.scss']
})
export class SkipSubscriptionComponent implements OnInit {
  skipSubscriptionDetails: SkipSubscriptionDetails = new SkipSubscriptionDetails();
  subscriptionId: any;
  date: Date;
  frequency: any
  itemDetails: Array<any> = [];
  itemId: any
  description: any
  updateDate: any
  constructor(public dialogRef: MatDialogRef<SkipSubscriptionComponent>,
    @Inject(MAT_DIALOG_DATA) public productData: any,
    private productService: ProductsService,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.itemDetails = [];
    this.subscriptionId = this.productData.skipSubscriptionDetails.subscriptionId;
    this.date = this.productData.skipSubscriptionDetails.date;
    this.frequency = this.productData.skipSubscriptionDetails.frequency;
    this.itemDetails = this.productData.skipSubscriptionDetails.skipCustomerSubscriptionItemVO;
    if (this.frequency.includes("week"))
      this.addWeeks(this.date, this.frequency);
    else
      this.addMonths(this.date, this.frequency);

  }

  private addWeeks(data, weeks) {
    let date = new Date(data);
    var day = new Date(data).getDay();
    date.setDate(date.getDate() + parseInt(weeks.substring(0, 1)) * 7);
    this.updateDate = new Date(date).toLocaleDateString();
  }

  private addMonths(data, months) {
    let date = new Date(data);
    date.setMonth(date.getMonth() + parseInt(months.substring(0, 1)));
    this.updateDate = new Date(date).toLocaleDateString();

  }

  onClose() {
    this.dialogRef.close();
  }
}
